import { buildPrompt } from '@/ai/utils/promptBuilder'
import { examples } from '@/ai/prompts/common/examples'
import { transformWorkflow } from '@/ai/utils/transformWorkflow'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { getJsonOutputFormatting } from '@/ai/prompts/common/formatting'
import { createUserMessage, createSystemMessage } from '@/ai/utils/promptUtils'

export const buildWriteModelPrompt = ({ eventId, workflow }) => {
  const messages = []

  const systemContent = buildPrompt([systemMessages.EVENT_MODELING_DDD_EXPERT])
  messages.push(createSystemMessage(systemContent))

  const promptSections = []

  const { events, entities, eventIdToLongIdMap } = transformWorkflow(workflow)
  const event = events.find((e) => eventIdToLongIdMap[e.id] === eventId) || {}

  const commandName = event.causedByCommand?.name
  const aggregateName = event.aggregate?.name

  promptSections.push({
    title: 'Request',
    content: `
      Focus on domain event ${event.id} (${event.role} - ${event.name}). For this step in the process,
      create a set of input fields. You are designing a simple input form (or mockup or wireframe) with data
      fields to be filled in and submitted by the actor (or role), in order to invoke the command "${commandName}"
      on the aggregate "${aggregateName}", for this step of the process. Each data field is an input field that the user
      (or system, if automated) can fill in. The form reflects the information requested from the actor in order
      to invoke the command on the aggregate. The number of input fields per step can vary, but it is
      usually between 4 and 8. In most of the cases the generated data fields should match with the data fields
      of the entity and include the primary key field (id) of the entity. A data field name must be in camel case
      format (e.g., 'productName' instead of 'Product Name'). A data field name must be at most 30 characters long.
    `
  })

  promptSections.push({
    title: 'Current Workflow (JSON format)',
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify({ domainEvents: events })
  })

  promptSections.push({
    title: 'Existing Entities (Optional): Use this information if applicable.',
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify({ entities })
  })

  const writeModelExample = { writeModel: examples.commandExampleCreateOrder }

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonOutputFormatting('writeModel', JSON.stringify(writeModelExample))
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
